module.exports = __webpack_public_path__ + "static/rollerblade-preview-748103ab5031b5d774d6864fbf55370a.jpg";